import React, { useContext } from "react";
import { ThemeContext } from "../../lib/main-context";
import { useTranslation } from "../../i18n/TranslationProvider";

import PillButton from "./PillButton";

const ThemeChanger = () => {
  const { dark, toggleTheme } = useContext(ThemeContext);
  const { t } = useTranslation();

  return (
    <div className="flex justify-center md:justify-end my-4">
      <PillButton className="pillBtn" onClick={() => toggleTheme()}>
        {dark ? t("themechanger.off") : t("themechanger.on")}
      </PillButton>
    </div>
  );
};

export default ThemeChanger;